(function(){
    let video_buttons = document.querySelectorAll('.product-page__watch-product-overview');
    let modal_conatainer = document.getElementById('proudct-overview-modal');
    let close = document.querySelector('.product-page__modal__close');
    let opening = false;

    function show() {
        opening = true;
        modal_conatainer.style['display'] = 'block';
    }

    function hide() {
        if(opening) {
            opening = false;
            return;
        }
        modal_conatainer ? modal_conatainer.style['display'] = 'none' : null;
    }

    for(let i = 0; i < video_buttons.length; i++) {
        video_buttons[i].addEventListener('click', show);
    }
    close?.addEventListener('click', hide);
    document.addEventListener('click', hide);
})();
